import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaWallet, FaHandHoldingUsd, FaClock, FaChartLine } from 'react-icons/fa';
import { useAdmin } from '../context/AdminContext';

const ReportsDashboard = () => {
  const { withdraws ,fetchWithdrawRequests,fetchCalculateWithdrawRequests} = useAdmin();
// console.log(TotalMANAULInvestmentAMT);
useEffect(()=>{
// fetchCalculateWithdrawRequests();
    fetchWithdrawRequests();
    // fetchTotalInvestment();
    // fetchTotalManualInvestment();
},[])
  // Total Sum Calculation
  const totalSum = withdraws.reduce((acc, curr) => acc + (curr.amount || 0), 0);
//   const stats = [
//     { 
//     title: 'Total Investment', 
//     value: `$${(totalInvestment || 0).toLocaleString()}`, 
//     icon: FaWallet, 
//     color: 'text-emerald-600', 
//     bg: 'bg-emerald-50' 
//   },{ 
//     title: 'Manual Plan Active', 
//     value: `$${(TotalMANAULInvestmentAMT || 0).toLocaleString()}`, 
//     icon: FaChartLine, 
//     color: 'text-purple-600', 
//     bg: 'bg-purple-50' 
//   },
// { 
//     title: 'Total Withdrawal', 
//     // Yahan fix lagaya hai: agar undefined ho toh 0 use hoga
//     value: `$${(TotalAmtwithdraws || 0).toLocaleString()}`, 
//     icon: FaHandHoldingUsd, 
//     color: 'text-blue-600', 
//     bg: 'bg-blue-50' 
//   },  ]

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved': return 'bg-emerald-50 text-emerald-700';
      case 'processing': return 'bg-amber-50 text-amber-700';
      case 'pending': return 'bg-rose-50 text-rose-700';
      default: return 'bg-slate-100 text-slate-700';
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-8">
      
      {/* Stats Cards */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {stats.map((stat, i) => (
          <div key={i} className="bg-white p-8 rounded-[2rem] border border-slate-100 shadow-sm flex items-center justify-between">
            <div>
              <p className="text-slate-500 font-bold text-[10px] uppercase tracking-widest">{stat.title}</p>
              <h3 className="text-3xl font-black text-slate-900 mt-2">{stat.value}</h3>
            </div>
            <div className={`p-4 rounded-2xl ${stat.bg} ${stat.color}`}>
              <stat.icon size={24} />
            </div>
          </div>
        ))}
      </div> */}

      {/* Table Section */}
      <div className="bg-white rounded-[2rem] border border-slate-100 shadow-sm overflow-hidden">
        <div className="p-8 border-b border-slate-100 flex justify-between items-center">
          <h2 className="text-xl font-bold text-slate-900">All Withdrawal Requests</h2>
          <div className="bg-slate-900 text-white px-4 py-2 rounded-xl text-sm font-bold">
            Total Withdraws (current month): ${totalSum.toLocaleString()}
          </div>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="text-slate-400 text-[10px] font-black uppercase tracking-widest bg-slate-50">
                <th className="px-8 py-4">User</th>
                <th className="px-8 py-4">Amount</th>
                <th className="px-8 py-4">Network</th>
                <th className="px-8 py-4">Status</th>
                <th className="px-8 py-4">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {withdraws.length > 0 ? (
                withdraws.map((req, i) => (
                  <tr key={i} className="hover:bg-slate-50 transition-colors">
                    <td className="px-8 py-5 font-bold text-slate-900">{req.userName}</td>
                    <td className="px-8 py-5 font-bold text-emerald-600">${req.amount}</td>
                    <td className="px-8 py-5 text-slate-600">{req.network}</td>
                    <td className="px-8 py-5">
                      <span className={`px-3 py-1 rounded-full text-[11px] font-bold ${getStatusColor(req.status)}`}>
                        {req.status?.toUpperCase()}
                      </span>
                    </td>
                    <td className="px-8 py-5 text-slate-600 text-sm">
                      {new Date(req.createdAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-8 py-10 text-center text-slate-400">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>
  );
};

export default ReportsDashboard;